'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "open", "options", "onButtonClick", "placement", "tooltip", "value", "splitButtonTestId", "disabled"];
import Controllable from 'UIComponents/decorators/Controllable';
import { DropdownCaret } from 'foundations-components/transitional/components/AbstractDropdown';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { TextToolbarIcon } from './TextToolbarIcon';
import UITextToolbarButton from './UITextToolbarButton';
import UIAbstractIconDropdown from './abstract/UIAbstractIconDropdown';
import SimpleStyledClickable from './internal/SimpleStyledClickable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SplitSelectCaretButton = props => {
  return /*#__PURE__*/_jsx(SimpleStyledClickable, Object.assign({}, props, {
    borderStartStartRadius: "0",
    borderEndStartRadius: "0"
  }));
};
class UITextToolbarSplitSelectCore extends Component {
  constructor(...args) {
    super(...args);
    this.refCallback = element => {
      this._popoverTarget = element;
    };
  }
  render() {
    const _this$props = this.props,
      {
        active,
        open,
        options,
        onButtonClick,
        placement,
        tooltip,
        value,
        splitButtonTestId,
        disabled
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const selectedOption = options.find(({
      value: val
    }) => val === value);
    const renderedIcon = selectedOption ? /*#__PURE__*/_jsx(TextToolbarIcon, {
      disabled: disabled,
      icon: selectedOption.Icon,
      verticalAlign: "sub",
      size: "300"
    }) : null;
    const popoverProps = {
      target: this._popoverTarget
    };
    return /*#__PURE__*/_jsx(Tooltip, {
      open: open ? false : undefined,
      placement: placement,
      title: tooltip,
      disabled: disabled,
      children: /*#__PURE__*/_jsxs(ButtonGroup, {
        display: "flex",
        "data-test-id": `${splitButtonTestId}-group`,
        children: [/*#__PURE__*/_jsx(UITextToolbarButton, {
          "data-test-id": splitButtonTestId,
          hovered: open ? true : undefined,
          onClick: onButtonClick,
          buttonRef: this.refCallback,
          selected: active,
          disabled: disabled,
          borderStartEndRadius: "0",
          borderEndEndRadius: "0",
          paddingInline: "50",
          children: renderedIcon
        }), /*#__PURE__*/_jsx(UIAbstractIconDropdown, Object.assign({
          Button: SplitSelectCaretButton,
          caretRenderer: /*#__PURE__*/_jsx(DropdownCaret, {
            buttonUse: "transparent",
            marginInlineStart: "0",
            marginInlineEnd: "100",
            marginBlockStart: "250"
          }),
          open: open,
          options: options,
          popoverProps: popoverProps,
          value: value,
          disabled: disabled,
          padding: "0"
        }, rest))]
      })
    });
  }
}
UITextToolbarSplitSelectCore.displayName = 'UITextToolbarSplitSelectCore';
UITextToolbarSplitSelectCore.defaultProps = Object.assign({}, UIAbstractIconDropdown.defaultProps, {
  active: false,
  placement: 'bottom'
});
UITextToolbarSplitSelectCore.propTypes = Object.assign({}, UIAbstractIconDropdown.propTypes, {
  active: PropTypes.bool,
  onButtonClick: PropTypes.func,
  splitButtonTestId: PropTypes.string
});
const UITextToolbarSplitSelect = Controllable(UITextToolbarSplitSelectCore, ['open', 'value']);
UITextToolbarSplitSelect.displayName = 'UITextToolbarSplitSelect';
export default UITextToolbarSplitSelect;